import type { Location } from 'history'
import history from 'src/util/history'
import qs from 'qs'
import { getUrlQuery } from './getUrlQuery'
import omitBy from 'lodash/omitBy'
import isUndefined from 'lodash/isUndefined'
import isNull from 'lodash/isNull'

// @ts-ignore - fixes error when hot reloading
if (!qs._parse) {
  require('qs-numbers')(qs)
}
/**
 * When React hooks ship to production, we can replace this
 */

export function setUrlQuery(args: { location: Location<any>; params: any; replaceParams?: boolean }) {
  let params = { ...args.params }

  if (!args.replaceParams) {
    const previousParams = getUrlQuery({ location: args.location })
    params = omitBy(
      {
        ...(previousParams as any),
        ...args.params
      },
      (val) => isUndefined(val) || isNull(val)
    )
  }

  return history.replace({
    pathname: args.location.pathname,
    search: qs.stringify(params, { skipNulls: true }),
    state: args.location.state
  })
}
